import { useEffect, useState } from "react";
import { useUIStore } from "../../../../stores/UIStore";
import Grape from "../../../../components/Grape/Grape";
import { useParams } from "react-router-dom";
import { findForm } from "../../../../api/FormsAPI";
import { LoadingOverlay } from "@mantine/core";

const FormEdit = () => {
  const { formId } = useParams();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState(null);

  useEffect(() => {
    setLoading(true);
    findForm(formId)
      .then((res) => {
        setForm(res.data.form_profile);
      })
      .finally(() => setLoading(false));
    useUIStore.getState().setHeaderClosed(true);

    return () => {
      useUIStore.getState().setHeaderClosed(false);
    };
  }, [formId]);

  return loading ? <LoadingOverlay visible /> : <Grape defaultForm={form} />;
};

export default FormEdit;
